import { DetalhamentoGrupo } from "./DetalhamentoGrupo";

export class CheckupDetalhamento {

	constructor(grupos: DetalhamentoGrupo[]) {
    this.grupos = grupos;
	}
  grupos: DetalhamentoGrupo[];
}